export default __webpack_public_path__ + "static/desktop-img-on-top-4f4e0acd1ce39babc782e9665cb5d5e8.png";